import { Link, useLocation } from 'react-router-dom';
import {
  LayoutDashboard, Truck, CalendarDays, FileText,
  Target, Users, Trophy, Settings,
} from 'lucide-react';
import { clsx } from 'clsx';

const NAV_ITEMS = [
  { path: '/', label: 'Inicio', icon: LayoutDashboard },
  { path: '/vehicles', label: 'Vehículos', icon: Truck },
  { path: '/availability', label: 'Disponibilidad', icon: CalendarDays },
  { path: '/documents', label: 'Documentos', icon: FileText },
  { path: '/opportunities', label: 'Oportunidades', icon: Target },
  { path: '/referrals', label: 'Referidos', icon: Users },
  { path: '/gamification', label: 'Logros', icon: Trophy },
  { path: '/settings', label: 'Configuración', icon: Settings },
];

export function Sidebar() {
  const location = useLocation();

  return (
    <nav className="fixed top-16 left-0 w-64 h-[calc(100vh-4rem)] bg-white border-r border-gray-100 overflow-y-auto py-4" aria-label="Navegación principal">
      <div className="px-3 space-y-1">
        {NAV_ITEMS.map(({ path, label, icon: Icon }) => {
          const isActive = path === '/' ? location.pathname === '/' : location.pathname.startsWith(path);
          return (
            <Link
              key={path}
              to={path}
              className={clsx(
                'flex items-center gap-3 px-3 py-2.5 rounded-xl text-sm font-medium transition-all duration-200',
                isActive
                  ? 'bg-brand-yellow text-brand-black'
                  : 'text-gray-600 hover:bg-gray-50 hover:text-brand-black'
              )}
            >
              <Icon size={20} />
              {label}
            </Link>
          );
        })}
      </div>
    </nav>
  );
}
